import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_10059_54218)">
      <path
        d="M9.17188 2.375H8.67298C8.46228 1.34233 7.54697 0.5625 6.45312 0.5625H5.54688C4.45303 0.5625 3.53727 1.34233 3.32702 2.375H2.82812C1.57886 2.375 0.5625 3.39136 0.5625 4.64062V9.17188C0.5625 10.4211 1.57886 11.4375 2.82812 11.4375H9.17188C10.4211 11.4375 11.4375 10.4211 11.4375 9.17188V4.64062C11.4375 3.39136 10.4211 2.375 9.17188 2.375ZM5.54688 1.46875H6.45312C7.044 1.46875 7.54742 1.84756 7.73456 2.375H4.26544C4.45258 1.84756 4.956 1.46875 5.54688 1.46875ZM2.82812 3.28125H9.17188C9.92134 3.28125 10.5312 3.89116 10.5312 4.64062V5.09375H9.17188V4.64062C9.17188 4.3905 8.96933 4.1875 8.71875 4.1875C8.46817 4.1875 8.26562 4.3905 8.26562 4.64062V5.09375H3.73438V4.64062C3.73438 4.3905 3.53183 4.1875 3.28125 4.1875C3.03067 4.1875 2.82812 4.3905 2.82812 4.64062V5.09375H1.46875V4.64062C1.46875 3.89116 2.07866 3.28125 2.82812 3.28125ZM9.17188 10.5312H2.82812C2.07866 10.5312 1.46875 9.92134 1.46875 9.17188V6H2.82812V6.45312C2.82812 6.70325 3.03067 6.90625 3.28125 6.90625C3.53183 6.90625 3.73438 6.70325 3.73438 6.45312V6H8.26562V6.45312C8.26562 6.70325 8.46817 6.90625 8.71875 6.90625C8.96933 6.90625 9.17188 6.70325 9.17188 6.45312V6H10.5312V9.17188C10.5312 9.92134 9.92134 10.5312 9.17188 10.5312Z"
        fill="#6C7478"
      />
    </g>
    <defs>
      <clipPath id="clip0_10059_54218">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CompanyIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default CompanyIcon;
